import React, { Component } from 'react';
import { Button, Container, Col, Card, Row, InputGroup, Image, Form } from 'react-bootstrap';
import ImageCrop from '../ImageCrop/ImageCrop';
import Footers from '../../component/Footers/Footer';
import avatar from '../../avatar.svg';
import Loader from '../../component/Loader/Loader';
import { withRouter } from 'react-router-dom'
import axios from 'axios';
import ErrorModal from '../../component/ErrorModal/ErrorModal';
import Headers from '../../component/Headers/Headers';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import MediaQuery from 'react-responsive';
import { msalInstance } from "../../msalConfig";
import Resizer from 'react-image-file-resizer';
import imageCompression from 'browser-image-compression';

function readFile(file) {
    return new Promise(resolve => {
        const reader = new FileReader()
        reader.addEventListener('load', () => resolve(reader.result), false)
        reader.readAsDataURL(file)
    })
}

const resizeFile = (file, dimensions) => new Promise(resolve => {
    Resizer.imageFileResizer(file, dimensions.width, dimensions.height, 'JPEG', 100, 0,
        uri => {
            resolve(uri);
        }, 'base64');
});

const options = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 640,
    useWebWorker: true
}

class Upload extends Component {
    constructor(props) {
        super(props);
        this.inputChangedRef = React.createRef();
    }
    state = {
        imageUrl: null,
        imageName: "Choose file...",
        StudentID: '',
        StaffName: '',
        role: 'Student',
        isOHR: false,
        isOSE: false,
        checkSubmit: true

        //isLoading: false
        //accesstoken: this.props.location.state.accesstoken,
        //studentID: this.props.location.state.studentID
    };

    //Validation for onChange in Input File
    onFileChange = async e => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const minFileSize=process.env.REACT_APP_MINFILESIZE_REQUIRED;
            if (minFileSize!==null&& minFileSize!==undefined)
            {
                if (minFileSize==='YES')
                {
                if (file.size < 60000) {
               this.setState({
                   show: true,
                    isLoading: false,
                    errorMsg: 'Please upload a photo with a minimum 60kb file size'
                })
                e.target.value = null;
                return
            }
            }
        }

           /* if (file.size > 500000) {
                this.setState({
                    show: true,
                    isLoading: false,
                    errorMsg: 'Please upload a photo with a maximum 500kb file size'
                })
                e.target.value = null;
                return
            }*/

            if (fileExtension === 'jpg' || fileExtension === 'jpeg') {
                let imageDataUrl = await readFile(file)

                this.setState({
                    imageUrl: imageDataUrl,
                    imageName: file.name,
                    imageFile: file,
                    isLoading: false,
                    checkSubmit: false
                    // disableCrop: false,
                    // disableUpload: false,
                })

            } else {
                this.setState({
                    // disableCrop: true,
                    // disableUpload: true,
                    checkSubmit: true,
                    isLoading: false,
                    show: true,
                    errorMsg: 'Please upload a passport photo of .jpeg or .jpg'
                })
            }
        }
    }

    componentDidMount() {
        //authenticate whether user has login properly
        if (!this.props.location.state) {
            this.props.history.push('/')
        }
        console.log('state', this.props.location.state)
        console.log('role', this.props.role)

        //Check whether user type and show different upload page
        if (this.props.location.state) {
            console.log('userType', this.props.location.state.userType)
            if (this.props.location.state.userType === 'OSEAdmin') {
                console.log(this.props.staffName, this.props.studentID)
                if (this.props.staffName && this.props.studentID && this.props.role) {
                    this.setState({
                        StudentID: this.props.studentID,
                        StaffName: this.props.staffName,
                        role: this.props.role,
                        isOSE: true,
                        userid: localStorage.getItem('id')
                    })
                } else if (this.props.location.state.staffName && this.props.location.state.studentID && this.props.location.state.role) {
                    this.setState({
                        StudentID: this.props.location.state.studentID,
                        StaffName: this.props.location.state.staffName,
                        role: this.props.location.state.role,
                        isOSE: true,
                        userid: localStorage.getItem('id')
                    })
                } else {
                    this.setState({
                        isOSE: true,
                        userid: localStorage.getItem('id')
                    })
                }
            } else if (this.props.location.state.userType === 'OHRStaff') {
                if (this.props.staffName && this.props.studentID) {
                    this.setState({
                        StudentID: this.props.studentID,
                        StaffName: this.props.staffName,
                        isOHR: true,
                        userid: localStorage.getItem('id')
                    })
                }  else if (this.props.location.state.staffName && this.props.location.state.studentID && this.props.location.state.userType) {
                    this.setState({
                        StudentID: this.props.location.state.studentID,
                        StaffName: this.props.location.state.staffName,
                        isOHR: true,
                        userid: localStorage.getItem('id')
                    })
                } else {
                    this.setState({
                        isOHR: true,
                        userid: localStorage.getItem('id')
                    })
                }
            } else {
                this.setState({
                    userid: localStorage.getItem('id')
                })
            }
        }

        // if (this.props.role) {
        //     this.setState({
        //         role: this.props.role
        //     })
        // }



        // if (this.props.staffName || this.props.studentID) {
        //     console.log(this.props.staffName, this.props.studentID)
        //     if (this.props.userType) {
        //         this.setState({
        //             StudentID: this.props.studentID,
        //             StaffName: this.props.staffName,
        //             role: this.props.userType
        //         })
        //     } else {
        //         this.setState({
        //             StudentID: this.props.studentID,
        //             StaffName: this.props.staffName
        //         })
        //     }

        // }
    }

    inputChanged = () => {
        this.setState({ isLoading: true });
    }

    disableHandler = async ({ target: img }) => {
        //this.setState({isLoading: false})
        const height = img.naturalHeight
        const width = img.naturalWidth
        console.log(width + 'x' + height)
        const file = this.state.imageFile

        let dimensions = {
            width: 480,
            height: 640
        }


        if (width / height > 0.75) {
            console.log('in here')
            dimensions.width = 640 * (width / height)
            console.log('new dimensions', dimensions)

        } else if (width / height < 0.75) {
            dimensions.height = 480 * (height / width)
            console.log('new dimensions', dimensions)
        }

        if (height > 640 || width > 480) {
            const imageURL = await resizeFile(file, dimensions);
            // const compressedImageFile = await imageCompression(file, options);
            // console.log(compressedImageFile)
            // const imageURL = await readFile(compressedImageFile)
            

            const isIE = /*@cc_on!@*/false || !!document.documentMode;

            let resizefile

            let filename = this.props.location.state.studentID
            filename = filename.split('@')[0]
            if (this.state.isOHR || this.state.isOSE) {
                filename = this.state.StudentID
            }

            if (isIE) {
                //File constructor does not exist in IE and hence using blob with last modified date and name
                resizefile = await fetch(imageURL).then(r => r.blob());
                resizefile.lastModifiedDate = new Date();
                resizefile.name = filename + '.jpeg';
            } else {

                //File constructor works in other browser
                resizefile = await fetch(imageURL).then(r => r.blob()).then(blobFile => new File([blobFile], filename + '.jpeg', { type: "image/jpeg" }))
            }

            
            console.log(resizefile)

            this.setState({ imageUrl: imageURL, imageFile: resizefile })
            return;
        }

        console.log(width, height)

        //Validate the resolution of the image when onLoad
        if (height < 640  || width < 480) {
            console.log(width, height)
            this.setState({
                disableCrop: true,
                disableUpload: true,
                show: true,
                errorMsg: 'Please upload a photo with a minimum 480 x 640 dimension'
            })
        } else if (height > 640  || width > 480) {
            this.setState({
                disableCrop: false,
                disableUpload: true,
                show: true,
                errorMsg: 'The uploaded photo is more than 480x640 dimension. Please crop the photo using the crop function'
            })            
        } else {
            this.setState({
                disableCrop: false,
                disableUpload: false
            })
        }
    }

    cropHandler = () => {
        console.log("Inside Crop handler");
        if (this.state.role === 'Student' || this.state.role === 'Staff') {
            this.setState({
                showCrop: true,
                userType: this.state.role,
                role:this.state.role
            })  
        } else {
            this.setState({
                showCrop: true,
                role:this.state.role
            })
        }

    }

    uploadHandler = event => {
        this.setState({ isLoading: true });
        event.preventDefault();

        const url = process.env.REACT_APP_VALIDATEIMAGE

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data'
        };
        if (this.props.location.state.accesstoken) {
            headers["Authorization"] = `Bearer ${this.props.location.state.accesstoken}`;
        }

        //Retrieve image base64 string
        //var imageBuffer = this.state.imageUrl.split(',');

        const fileExtension = this.state.imageName.split('.').pop();

        let userType = this.props.location.state.userType
        let filename = this.props.location.state.studentID
        filename = filename.split('@')[0]
        let userid = this.props.location.state.studentID
        userid = userid.split('@')[0]

        if (this.state.isOHR || this.state.isOSE) {
            filename = this.state.StudentID
            userid = this.state.StudentID
            userType = 'Staff'
        }

        if (this.state.role === 'Student' || this.state.role === 'Staff') {
            userType = this.state.role
        }

        if (this.state.isOHR) {
            filename = this.state.StudentID
            userid = this.state.StudentID
            userType = 'Staff'
        }

        console.log(this.state.imageFile)
        console.log("user type: "+this.props.location.state.userType)

        const form = new FormData();
        form.append('byteData', this.state.imageFile)
        form.append('filename', filename + '.' + fileExtension);
        form.append('userid', userid);
        form.append('usertype', userType);
        form.append('loginUserType',this.props.location.state.userType);//20240301
        

        for (var pair of form.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        axios.post(url, form, {
            headers: headers
        }).then((response) => {
            const result = response.data;
            console.log(result)
            if (result.uploadStatus || result.uploadRemarks) {
                this.setState({
                    //showResult: true,
                    isLoading: false,
                    //uploadStatus: result.uploadStatus,
                    //uploadRemarks: result.uploadRemarks
                })
                this.props.history.push({
                    pathname: '/Result',
                    state: {
                        uploadStatus: result.uploadStatus,
                        uploadRemarks: result.uploadRemarks,
                        studentID: this.props.location.state.studentID,
                        staffName: this.props.location.state.StaffName,
                        userType: this.props.location.state.userType,
                        accesstoken: this.props.location.state.accesstoken,
                        role: this.props.location.state.role
                    }
                })
            } else {
                this.setState({
                    show: true,
                    errorMsg: "No result available. Please try again",
                    isLoading: false
                })
            }
        }).catch((error) => {
            console.log(error)
            const url = process.env.REACT_APP_LOGEXCEPTION
            let headers = {
                'Content-Type': 'multipart/form-data'
            };

            headers["Authorization"] = `Bearer ${this.props.location.state.accesstoken}`;

            const form = new FormData();
            form.append('loggedinuserid', this.props.location.state.studentID)
            form.append('student_staff_id', userid);
            form.append('webapimethodname', process.env.REACT_APP_VALIDATEIMAGE);

            if (error.response) {
                form.append('error', error.response.status + ' ' + error.response.statusText);
            } else {
                form.append('error', error.message);
            }

            for (var pair of form.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }

            axios.post(url, form, { headers: headers }).then((response) => {
                if (error.response) {
                    if (error.response.status === '401') {
                        this.setState({
                            errorMsg: 'Your Session has expired. Please login again.',
                            show: true,
                            isLoading: false
                        })
                        localStorage.clear()
                        msalInstance.logout()
                    } else {
                        this.setState({
                            errorMsg: error.response.status + ' ' + error.response.statusText,
                            show: true,
                            isLoading: false
                        })
                    }
                } else {
                    this.setState({
                        show: true,
                        errorMsg: error.message,
                        isLoading: false
                    })
                }
            }).catch((error1) => {
                if (error.response) {
                    if (error.response.status === '401') {
                        this.setState({
                            errorMsg: 'Your Session has expired. Please login again.',
                            show: true,
                            isLoading: false
                        })
                        localStorage.clear()
                        msalInstance.logout()
                    } else {
                        this.setState({
                            errorMsg: error.response.status + ' ' + error.response.statusText,
                            show: true,
                            isLoading: false
                        })
                    }
                } else {
                    this.setState({
                        show: true,
                        errorMsg: error.message,
                        isLoading: false
                    })
                }
            });


        });
    }

    closeHandler = () => {
        this.setState({ show: false })
    }

    cancelHandler = () => {
        this.setState({
            imageUrl: null,
            imageName: "Choose file...",
            submit: false,
            checkSubmit: true,
            // StudentID: '',
            // StaffName: ''

        })
    }

    changeHandler = (e) => {
        const target = e.target;
        const name = target.name;

        if (name === "StudentID") {
            const isValidChar = !/[~`!@#$%\^&*()+=_\-\[\]\\';,/{}|\\":<>\? ]/g.test(e.target.value)

            if (isValidChar && e.target.value.length <= 20) {
                this.setState({ StudentID: e.target.value });
            }
        }

        if (name === "StaffName") {
            this.setState({ StaffName: e.target.value });
        }
    }

    dropdownSelect = (e) => {
        this.setState({
            role: e.value,
            StudentID: '',
            StaffName: ''
        })
    }

    previewHandler = () => {
        if (this.state.isOHR || this.state.isOSE) {
            if (this.state.StudentID === '' || this.state.StaffName === '') {
                let errormsg = 'Staff ID and Staff Name are required'
                if (this.state.role === 'Student') {
                    errormsg = 'Student ID and Student Name are required'
                }
                this.setState({
                    show: true,
                    isLoading: false,
                    errorMsg: errormsg
                })
                //e.target.value = null;
                return
            }

            if (this.state.role === 'Select Role' && this.state.isOSE) {
                this.setState({
                    show: true,
                    isLoading: false,
                    errorMsg: 'Role needs to be selected'
                })
                //e.target.value = null;
                return
            }
        }
            
            //Call ScanFile api
            this.setState({ isLoading: true });
            //preventDefault();

            const url = process.env.REACT_APP_SCANFILE

            let headers = {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            };
            if (this.props.location.state.accesstoken) {
                headers["Authorization"] = `Bearer ${this.props.location.state.accesstoken}`;
            }
                
            const form = new FormData();
            form.append('byteData', this.state.imageFile)
            form.append('userid',this.state.StudentID)
            form.append('filename',this.state.StudentID+'.jpg')
            form.append('usertype',this.state.role)
                
            for (var pair of form.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
            axios.post(url, form, {
                headers: headers
            }).then((response) => {
                const result = response.data;
                console.log(result)
                    
            if (result.uploadStatus === true) {
                this.setState({
                    isLoading: false
                })
                //call to preview method
                this.setState({ submit: true })
            }
            else if (result.uploadStatus === false) {
                this.setState({
                    show: true,
                    errorMsg: result.uploadRemarks,
                    isLoading: false
                })
            }
            else {
                this.setState({
                    show: true,
                    errorMsg: "No result available. Please try again",
                    isLoading: false
                })
            }
            }).catch((error) => {
                console.log(error)
                const url = process.env.REACT_APP_LOGEXCEPTION
                let headers = {
                    'Content-Type': 'multipart/form-data'
                };

                headers["Authorization"] = `Bearer ${this.props.location.state.accesstoken}`;

                const form = new FormData();
                form.append('loggedinuserid', this.props.location.state.studentID)
                form.append('student_staff_id', this.props.location.state.StudentID);
                form.append('webapimethodname', process.env.REACT_APP_VALIDATEIMAGE);

                if (error.response) {
                    form.append('error', error.response.status + ' ' + error.response.statusText);
                } else {
                    form.append('error', error.message);
                }

                for (var pair of form.entries()) {
                    console.log(pair[0] + ', ' + pair[1]);
                }

                axios.post(url, form, { headers: headers }).then((response) => {
                    if (error.response) {
                        if (error.response.status === '401') {
                            this.setState({
                                errorMsg: 'Your Session has expired. Please login again.',
                                show: true,
                                isLoading: false
                            })
                            localStorage.clear()
                            msalInstance.logout()
                        } else {
                            this.setState({
                                errorMsg: error.response.status + ' ' + error.response.statusText,
                                show: true,
                                isLoading: false
                            })
                        }
                    } else {
                        this.setState({
                            show: true,
                            errorMsg: error.message,
                            isLoading: false
                        })
                    }
                }).catch((error1) => {
                    if (error.response) {
                        if (error.response.status === '401') {
                            this.setState({
                                errorMsg: 'Your Session has expired. Please login again.',
                                show: true,
                                isLoading: false
                            })
                            localStorage.clear()
                            msalInstance.logout()
                        } else {
                            this.setState({
                                errorMsg: error.response.status + ' ' + error.response.statusText,
                                show: true,
                                isLoading: false
                            })
                        }
                    } else {
                        this.setState({
                            show: true,
                            errorMsg: error.message,
                            isLoading: false
                        })
                    }
                });
            });
    }

    render() {
        if (this.state.imageUrl && this.props.location.state.accesstoken && this.state.showCrop) {
            if (this.state.isOHR) {
                return <ImageCrop
                    image={this.state.imageUrl}
                    staffName={this.state.StaffName}
                    accesstoken={this.props.location.state.accesstoken}
                    studentID={this.state.StudentID}
                    imageName={this.state.imageName}
                    loggedinUser={this.props.location.state.studentID}
                    userType="Staff"
                    type='OHRStaff'
                    role="Staff"
                />;
            } else if (this.state.isOSE) {
                return <ImageCrop
                    image={this.state.imageUrl}
                    staffName={this.state.StaffName}
                    accesstoken={this.props.location.state.accesstoken}
                    studentID={this.state.StudentID}
                    imageName={this.state.imageName}
                    userType={this.state.role}
                    loggedinUser={this.props.location.state.studentID}
                    type='OSEAdmin'
                    role={this.state.role}
                />;
            } else {
                return <ImageCrop
                    image={this.state.imageUrl}
                    //file={this.state.imageFile}
                    accesstoken={this.props.location.state.accesstoken}
                    studentID={this.props.location.state.studentID}
                    imageName={this.state.imageName}
                    userType={this.props.location.state.userType}
                    type='Student'
                    role='Student'
                />;
            }
        }

        let image =
            <Col className="my-auto">
                <Image src={avatar} thumbnail />
            </Col>
        let staffpage = null;

        if (this.state.isOHR) {
            staffpage =
                <div>
                    <div className="px-3 py-2">
                        <Form.Label className="text-success"><b>Staff ID:</b></Form.Label>
                        <Form.Label className="text-danger"><b>*</b></Form.Label>
                        <Form.Control
                            type="text"
                            name="StudentID"
                            required
                            max="20"
                            value={this.state.StudentID}
                            onChange={(event) => { this.changeHandler(event) }}
                        />
                    </div>
                    <div className="px-3 pt-2">
                        <Form.Label className="text-success"><b>Staff Name:</b></Form.Label>
                        <Form.Label className="text-danger"><b>*</b></Form.Label>
                        <Form.Control
                            type="text"
                            name="StaffName"
                            required
                            max="20"
                            value={this.state.StaffName}
                            onChange={(event) => { this.changeHandler(event) }}
                        />
                    </div>
                </div>
        }

        if (this.state.isOSE) {
            staffpage =
                <div>
                    <div className="px-3 pt-4">
                        {(this.state.role === 'Student' || this.state.role === 'Staff') ? <Form.Label className="text-success"><b>{this.state.role}:</b></Form.Label> : <Form.Label className="text-success"><b>Student:</b></Form.Label>}
                        <Form.Label className="text-danger"><b>*</b></Form.Label>
                        <Dropdown options={['Student', 'Staff']} onChange={(e) => this.dropdownSelect(e)} value={this.state.role} placeholder="Select an option" />
                    </div>
                    <div className="px-3 py-2">
                        {(this.state.role === 'Student' || this.state.role === 'Staff') ? <Form.Label className="text-success"><b>{this.state.role} ID:</b></Form.Label> : <Form.Label className="text-success"><b>Student ID:</b></Form.Label>}
                        <Form.Label className="text-danger"><b>*</b></Form.Label>
                        <Form.Control
                            type="text"
                            name="StudentID"
                            required
                            max="20"
                            value={this.state.StudentID}
                            onChange={(event) => { this.changeHandler(event) }}
                        />
                    </div>
                    <div className="px-3 pt-2">
                        {(this.state.role === 'Student' || this.state.role === 'Staff') ? <Form.Label className="text-success"><b>{this.state.role} Name:</b></Form.Label> : <Form.Label className="text-success"><b>Student Name:</b></Form.Label>}
                        <Form.Label className="text-danger"><b>*</b></Form.Label>
                        <Form.Control
                            type="text"
                            name="StaffName"
                            required
                            value={this.state.StaffName}
                            onChange={(event) => { this.changeHandler(event) }}
                        />
                    </div>

                </div>
        }


        let uploadFunctions =
            <Col className="my-auto">
                {staffpage}
                <InputGroup className="px-3 py-5">
                    <div className="custom-file">
                        <input
                            type="file"
                            className="custom-file-input"
                            onChange={(event) => {
                                this.onFileChange(event)
                            }}
                            ref={this.inputChangedRef}
                            accept="image/jpg,image/jpeg" />
                        <label className="custom-file-label">{this.state.imageName}</label>
                    </div>
                </InputGroup >
                <div className="pb-4 text-center">
                    <Button variant="success" onClick={this.previewHandler} disabled={this.state.checkSubmit}>
                        Preview
                    </Button>
                </div>

            </Col>

        let displayCropOption =
            <Card className="my-5 shadow">
                <Card.Header className="bg-brandcolor text-center">
                    <h5 className="text-white">Preview</h5>
                </Card.Header>
                <Card.Body className="text-center outline-parent">
                    <div className="outline"></div>
                    <Image src={this.state.imageUrl} thumbnail onLoad={this.disableHandler.bind(this)} />
                </Card.Body>
                <Card.Footer className="text-center">
                    <Button variant="success" onClick={this.cropHandler} disabled={this.state.disableCrop}>
                        Crop Photo
                    </Button>{' '}
                    <Button variant="success" onClick={this.uploadHandler} disabled={this.state.disableUpload}>
                        Upload Photo
                    </Button>{' '}
                    <Button variant="success" onClick={this.cancelHandler}>
                        Cancel
                    </Button>
                </Card.Footer>
            </Card>

        let displayUpload =
            <Card className="my-5 shadow">
                <Row>
                    <MediaQuery minDeviceWidth={1000}>
                        {image}
                    </MediaQuery>

                    {uploadFunctions}
                </Row>
            </Card>

        return (
            <div>
                <Headers user={this.state.userid} />
                <Container>
                    {this.state.isLoading ? <Loader isLoading={this.state.isLoading} /> : null}
                    <MediaQuery minDeviceWidth={800}>
                        <Row>
                            <Col sm={12} md={7} lg={7} className="mx-auto">
                                {this.state.submit ? displayCropOption : displayUpload}
                            </Col>
                           
                        </Row>
                    </MediaQuery>

                    <MediaQuery maxDeviceWidth={799}>
                        <Row>
                            <Col sm={12} md={9} lg={8} className="mx-auto pt-5">
                              
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={9} lg={8} className="mx-auto">
                                {this.state.submit ? displayCropOption : displayUpload}
                            </Col>
                        </Row>
                    </MediaQuery>

                </Container>
                <ErrorModal msg={this.state.errorMsg} show={this.state.show} click={() => this.closeHandler()} />
                <Footers />
            </div>
        );
    }

}

export default withRouter(Upload);